// Functions to handle video block logic
export function videoBlockModifyInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		const videoButtons = document.querySelectorAll( '.wp-block-video-overlay' );
		const videos = document.querySelectorAll( 'video' );

		function handleVideo ( video, overlay = null ) {
			if ( overlay === null) {
				overlay = video.parentNode.querySelector( '.wp-block-video-overlay' );
			}
			if ( video.paused ) {
				overlay.classList.add( 'hidden' );
				video.play();
			} else {
				overlay.classList.remove( 'hidden' );
				video.pause();
			}
		}

		videoButtons.forEach( ( btn ) => {
			btn.querySelector( 'button' ).onclick = function( e ) {
				const video = btn.parentNode.querySelector( 'video' );
				
				handleVideo( video, btn );
			};
		} );

		videos.forEach( ( video ) => {
			video.onclick = function( e ) {
				handleVideo( e.target );
			}
		} );
	})
}